import _ from 'lodash';
import * as types from '../actions/actionTypes';
import { dataScreenOptions, resetGraphData } from '../util/SalesCatalystUtils';
import initialState from './initialState';
import { SC_COMPETITORS_COMPARISON } from '../constants';

/* const initialState = {
  salesCatalystBase: undefined,
  brandSelection: {
    audience: [],
    subAudience: [],
    competitors: [],
    market: [],
  },
  pitchSelection: {
    audience: [],
    subAudience: [],
    competitors: [],
    market: [],
  },
  selectedTemplates: {
    brand: {},
    pitch: {},
  },
  dataSelection: {
    targetMarket: [],
    entity: [],
    competitor: [],
    category: {},
    brand: [],
    targetEntityOverlap: {},
  },
  dataOnScreen: {
    targetMarket: false,
    competition: false,
    mediaPackage: false,
  },
  graphData: {
    scTargetEntity: {},
    scTargetEntityBrand: {},
    scTarget: {},
    scTargetBrand: {},
    scBrands: {},
  },
  scAttitudesDisplayList: [],
  scDemoDisplayList: [],
  scMediaPackageInputFlag: true,
  chartSortInfo: {
    index: 0,
    type: 'desc',
    sortBy: 'Index',
  },
}; */

const generateObject = (obj, value) => {
  let result = { ...obj };
  result = value;
  return result;
};

export default (state = initialState.salesCatalyst, action) => {
  switch (action.type) {
    case types.SALES_BRANDS_SECTION_SEARCH_RESULT:
      {
        if (action.payload.length === 0) {
          action.payload = undefined;
        }
        return {
          ...state,
          salesBrandSectionSearchResult: action.payload,
        };
      }


    case types.SAVE_SALES_CATALYST_BASE_INFO:
      {
        return {
          ...state,
          salesCatalystBase: action.payload,
        };
      }

    case types.REMOVE_SALES_CATALYST_BASE_INFO:
      {
        return {
          ...state,
          salesCatalystBase: undefined,
        };
      }

    case types.RESET_SALES_CATALYST:
      {
        return {
          ...state,
          salesCatalystBase: undefined,
          brandSelection: {
            audience: [],
            subAudience: [],
            competitors: [],
            market: [],
          },
          pitchSelection: {
            audience: [],
            subAudience: [],
            competitors: [],
            market: [],
          },
          selectedTemplates: {
            brand: {},
            pitch: {},
          },
          scAttitudesDisplayList: [],
          scDemoDisplayList: [],
        };
      }

    case types.RESET_SALES_BRAND_SUMMARY:
      {
        return {
          ...state,
          brandSelection: {
            audience: [],
            subAudience: [],
            competitors: [],
            market: [],
          },
          selectedTemplates: { ...state.selectedTemplates, brand: {} },
        };
      }

    case types.RESET_SALES_PITCH_SUMMARY:
      {
        return {
          ...state,
          pitchSelection: {
            audience: [],
            subAudience: [],
            competitors: [],
            market: [],
          },
          selectedTemplates: { ...state.selectedTemplates, pitch: {} },
        };
      }

    case types.ADD_AUDIENCE_DATA_POINTS:
      {
        let subCategoryData = _.cloneDeep(state[action.mainCategory][action.subCategory]);
        if (_.isArray(action.payload)) {
          subCategoryData = action.payload;
        } else {
          subCategoryData = [...subCategoryData, action.payload];
        }
        return {
          ...state,
          [action.mainCategory]: {
            ...state[action.mainCategory],
            [action.subCategory]: subCategoryData,
          },
        };
      }
    case types.CLEAR_SALES_BRANDS_SECTION_SEARCH_RESULT:
      {
        return {
          ...state,
          salesBrandSectionSearchResult: [],
        };
      }

    case types.UPDATE_SALES_CATALYST_SELECTION:
      {
        const copyOfSelectionObject = _.cloneDeep(
          state[action.category.mainCategory][action.category.subCategory]);
        copyOfSelectionObject[action.data.indexToUpdate].defId = action.data.defId;
        copyOfSelectionObject[action.data.indexToUpdate].expId = action.data.expressionId;
        copyOfSelectionObject[action.data.indexToUpdate].expression = action.data.labelExpression;
        copyOfSelectionObject[action.data.indexToUpdate].label = action.data.label;
        return {
          ...state,
          [action.category.mainCategory]: {
            ...state[action.category.mainCategory],
            [action.category.subCategory]: copyOfSelectionObject,
          },
        };
      }


    case types.DELETE_INPUT_TABLE_ITEM:
      {
        const index = action.payload.index;
        const field = action.payload.field;
        switch (field) {
          case 'brand-aud':
            return {
              ...state,
              brandSelection: {
                audience: [],
                subAudience: state.brandSelection.subAudience,
                competitors: state.brandSelection.competitors,
                market: state.brandSelection.market,
              },
            };
          case 'brand-subaud':
            {
              let subAdienceArr = _.cloneDeep(state.brandSelection.subAudience);
              if (subAdienceArr.length > 1) {
                subAdienceArr.splice(index, 1);
              } else {
                subAdienceArr = [];
              }
              return {
                ...state,
                brandSelection: {
                  audience: state.brandSelection.audience,
                  subAudience: subAdienceArr,
                  competitors: state.brandSelection.competitors,
                  market: state.brandSelection.market,
                },
              };
            }
          case 'brand-compet':
            {
              let brandComeptitors = _.cloneDeep(state.brandSelection.competitors);
              if (brandComeptitors.length > 1) {
                brandComeptitors.splice(index, 1);
              } else {
                brandComeptitors = [];
              }
              return {
                ...state,
                brandSelection: {
                  audience: state.brandSelection.audience,
                  subAudience: state.brandSelection.subAudience,
                  competitors: brandComeptitors,
                  market: state.brandSelection.market,
                },
              };
            }
          case 'brand-market':
            return {
              ...state,
              brandSelection: {
                audience: state.brandSelection.audience,
                subAudience: state.brandSelection.subAudience,
                competitors: state.brandSelection.competitors,
                market: [],
              },
            };
          case 'pitch-aud':
            return {
              ...state,
              pitchSelection: {
                audience: [],
                subAudience: state.pitchSelection.subAudience,
                competitors: state.pitchSelection.competitors,
                market: state.pitchSelection.market,
              },
            };
          case 'pitch-subaud':
            {
              let pitchSubaudience = _.cloneDeep(state.pitchSelection.subAudience);
              if (pitchSubaudience.length > 1) {
                pitchSubaudience.splice(index, 1);
              } else {
                pitchSubaudience = [];
              }
              return {
                ...state,
                pitchSelection: {
                  audience: state.pitchSelection.audience,
                  subAudience: pitchSubaudience,
                  competitors: state.pitchSelection.competitors,
                  market: state.pitchSelection.market,
                },
              };
            }
          case 'pitch-compet':
            {
              let pitchCompetitors = _.cloneDeep(state.pitchSelection.competitors);
              if (pitchCompetitors.length > 1) {
                pitchCompetitors.splice(index, 1);
              } else {
                pitchCompetitors = [];
              }
              return {
                ...state,
                pitchSelection: {
                  audience: state.pitchSelection.audience,
                  subAudience: state.pitchSelection.subAudience,
                  competitors: pitchCompetitors,
                  market: state.pitchSelection.market,
                },
              };
            }
          case 'pitch-market':
            return {
              ...state,
              pitchSelection: {
                audience: state.pitchSelection.audience,
                subAudience: state.pitchSelection.subAudience,
                competitors: state.pitchSelection.competitors,
                market: [],
              },
            };
          default:
            return state;
        }
      }
    case types.UPDATE_DATA_ON_STUDY_CHANGE:
      {
        return {
          ...state,
          dataSelection: action.payload.dataSelection,
          salesCatalystBase: action.payload.salesCatalystBase,
        };
      }
    case types.UPDATE_BRAND_SELECTION_DATA:
      {
        return {
          ...state,
          brandSelection: action.payload,
        };
      }
    case types.UPDATE_PITCH_SELECTION_DATA:
      {
        return {
          ...state,
          pitchSelection: action.payload,
        };
      }
    case types.UPDATE_SELECTED_TEMPLATES_DATA:
      {
        return {
          ...state,
          selectedTemplates: { ...state.selectedTemplates,
            [action.payload.section]: action.payload.data },
        };
      }
    case types.DELETE_SALES_CATALYST_SELECTION: {
      const options = dataScreenOptions(action.payload.section);
      const dataOnScreenReset = _.clone(state.dataOnScreen);
      let subCategoryData = _.clone(state[action.payload.mainCategory][action.payload.subCategory]);
      _.forEach(options, data => {
        dataOnScreenReset[data] = false;
      });
      if (action.payload.index !== undefined) {
        _.remove(subCategoryData, (o, i) => i === action.payload.index);
      } else {
        subCategoryData = [];
      }
      return {
        ...state,
        dataOnScreen: dataOnScreenReset,
        [action.payload.mainCategory]: {
          ...state[action.payload.mainCategory],
          [action.payload.subCategory]: subCategoryData,
        },
      };
    }
    case types.RUN_SALES_CATALYST:
      {
        return {
          ...state,
          dataOnScreen: { ...state.dataOnScreen,
            targetMarket: action.payload.targetMarket,
            competition: action.payload.competition,
            mediaPackage: action.payload.mediaPackage },
        };
      }
    case types.RESET_ATTITUDE_DEMO_SECTION_DATA:
      {
        return {
          ...state,
          scAttitudesDisplayList: [],
          scDemoDisplayList: [],
        };
      }

    case types.SET_MEDIA_PACKAGE_INPUT_FLAG: {
      return {
        ...state,
        scMediaPackageInputFlag: action.payload,
      };
    }


    case types.GET_OVERLAP_SAMPLE_WEIGHTED_DATA:
      {
        return {
          ...state,
          dataSelection: { ...state.dataSelection,
            targetEntityOverlap: action.data },
        };
      }
    case types.RESET_OVERLAP_SAMPLE_WEIGHTED_DATA:
      {
        return {
          ...state,
          dataSelection: { ...state.dataSelection,
            targetEntityOverlap: {} },
        };
      }
    case types.RESET_SALES_CATALYST_SCREEN:
      {
        let dataOptions = {};
        dataOptions = _.cloneDeep(state.dataSelection);
        _.forEach(action.payload.options, val => {
          dataOptions[_.camelCase(val)] = [];
        });
        dataOptions.category = {};
        dataOptions.targetEntityOverlap = {};
        let modifiedSalesCatalystBase;
        let targetSelectedFilters;
        let comparisonSelectedOptions;
        let selectedPackageTemplate;
        if (action.payload.studyChangeBaseValid) {
          modifiedSalesCatalystBase = _.cloneDeep(state.salesCatalystBase);
        } else {
          modifiedSalesCatalystBase = undefined;
        }
        if (action.payload.noAddInfoReset) {
          targetSelectedFilters = _.cloneDeep(state.scTarget.selectedFilters);
          comparisonSelectedOptions = _.cloneDeep(state.scCompetition.selectedOptions);
          selectedPackageTemplate = _.cloneDeep(state.scConfiguration.package.selectedList);
        } else {
          targetSelectedFilters = {
            // when reset, pick from user preferences
            brands: action.payload.filters.brandFilters,
            media: action.payload.filters.mediaFilters,
          };
          comparisonSelectedOptions = {
            strengthsListDefault: undefined,
            weaknessesListDefault: undefined,
            activitiesListDefaults: [undefined, undefined, undefined],
          };
          selectedPackageTemplate = undefined;
        }
        return {
          ...state,
          salesCatalystBase: modifiedSalesCatalystBase,
          dataOnScreen: { ...state.dataOnScreen,
            targetMarket: false,
            competition: false,
            mediaPackage: false },
          dataSelection: dataOptions,
          graphData: {
            scTargetEntity: {},
            scTargetEntityBrand: {},
            scTarget: {},
            scTargetBrand: {},
            scBrands: {},
            scCompetitorsActivities: {},
            scCompetitors: {},
            scSubEntity: {},
            scCompetitorsComparison: [{}, {}, {}],
          },
          scAttitudesDisplayList: [],
          scDemoDisplayList: [],
          scCompetition: { ...state.scCompetition,
            selectedOptions: comparisonSelectedOptions,
          },
          scMediaPackageInputFlag: true,
          scTarget: {
            selectedFilters: targetSelectedFilters,
          },
          scConfiguration: { ...state.scConfiguration,
            package: { ...state.scConfiguration.package,
              selectedList: selectedPackageTemplate,
            },
          },
        };
      }

    case types.SHOW_SALES_ATTITUDE_MARKET_DATA:
      {
        const _scAttitudesDisplayList = [];
        const _scAttitudeIcon = action.payload[0].displayOptions;
        if (action.payload && action.payload.length > 0
          && action.payload[0].scAttitudes) {
          action.payload[0].scAttitudes.map(element => {
            const elementIcon = _scAttitudeIcon[element.group];
            element.icon = elementIcon.icon;
            _scAttitudesDisplayList.push(element);
            return null;
          });
        }
        return {
          ...state,
          scAttitudesDisplayList: _scAttitudesDisplayList,
        };
      }

    case types.SHOW_SALES_DEMO_MARKET_DATA: {
      const demographics = [];
      action.payload.data.forEach(element => {
        const demograph = {};
        demograph.label =
          element.headers !== undefined && element.headers[1] !== undefined
            ? element.headers[1].label
            : '';
        const displayOptions = element.displayOptions;
        demograph.detailGroups = [];
        _.forEach(element.detailGroups, (details, key) => {
          if (key !== 'General') {
            const detail = {};
            detail.name = key;
            let displayOption =
              displayOptions[key] !== undefined ? displayOptions[key] : 'index';
            displayOption = displayOption === 'percent' ? 'pct' : displayOption;
            const reverseList = _.reverse(
              _.sortBy(details, [
                function (o) {
                  if (
                    o.value !== undefined &&
                    o.value[displayOption] !== undefined
                  ) {
                    if (displayOption === 'pct') {
                      return _.toNumber(
                        o.value[displayOption].replace('%', ''),
                      );
                    }
                    return o.value[displayOption];
                  }
                  return -1;
                },
              ]),
            );
            detail.data = reverseList[0];
            demograph.detailGroups.push(detail);
          }
        });
        demographics.push(demograph);
      });
      return {
        ...state,
        scDemoDisplayList: demographics,
      };
    }

    case types.SET_DATA_ON_SCREEN_VAL:
      {
        return {
          ...state,
          dataOnScreen: { ...state.dataOnScreen,
            [action.payload.section]: action.payload.status },
        };
      }

    case types.UPDATE_SC_DATA_ON_SCREEN:
      {
        return {
          ...state,
          dataOnScreen: { ...state.dataOnScreen },
        };
      }

    case types.RESET_MEDIA_PACKAGE_CATEGORY:
      {
        return {
          ...state,
          dataSelection: { ...state.dataSelection,
            category: {} },
        };
      }

    case types.FETCH_BRAND_CATEGORY:
      {
        return {
          ...state,
          dataSelection: { ...state.dataSelection,
            category: action.data },
        };
      }

    case types.GET_BAR_CHART_REPORT:
      {
        let responseData = action.data;
        const graphDataObj = _.clone(state.graphData[action.reportType]);
        if (action.objIndex !== undefined) {
          graphDataObj[action.objIndex] = action.data;
          responseData = graphDataObj;
        }
        return {
          ...state,
          graphData: { ...state.graphData,
            [action.reportType]: responseData },
        };
      }

    case types.RESET_BAR_CHART_REPORT: {
      const options = resetGraphData(action.field);
      const graphReset = _.clone(state.graphData);
      _.forEach(options, data => {
        if (data === _.camelCase(SC_COMPETITORS_COMPARISON)) {
          graphReset[data] = [{}, {}, {}];
        } else {
          graphReset[data] = {};
        }
      });
      return {
        ...state,
        graphData: graphReset,
      };
    }

    case types.FETCH_BRAND:
      {
        return {
          ...state,
          dataSelection: { ...state.dataSelection,
            brand: action.brandDetails },
          dataOnScreen: { ...state.dataOnScreen,
              mediaPackage: false },
        };
      }
    case types.SET_CHART_SORT_INFO: {
      return {
        ...state,
        chartSortInfo: action.payload,
      };
    }
    case types.SET_SC_CONFIG_PACKAGE_DATA: {
      return {
        ...state,
        scConfiguration: { ...state.scConfiguration,
          package: { ...state.scConfiguration.package,
            [action.payload.key]: action.payload.value,
          },
        },
      };
    }
    case types.SHOW_SC_CONFIG_SCREEN: {
      return {
        ...state,
        scConfiguration: { ...state.scConfiguration,
          configPopupShow: action.payload,
        },
      };
    }
    case types.SET_SC_COMPETITION_DATA: {
      let data;
      if (action.payload.innObj !== undefined) {
        const tempData = _.clone(state.scCompetition[action.payload.key]);
        tempData[action.payload.innObj] = action.payload.value;
        data = tempData;
      } else {
        data = action.payload.value;
      }
      return {
        ...state,
        scCompetition: { ...state.scCompetition,
          [action.payload.key]: data,
        },
      };
    }
    case types.UPDATE_DATA_ON_SCREEN: {
      return {
        ...state,
        dataOnScreen: action.payload.dataOnScreen,
        graphData: action.payload.graphData,
      };
    }
    case types.SET_SC_TARGET_FILTER_DATA: {
      return {
        ...state,
        scTarget: { ...state.scTarget,
          selectedFilters: { ...state.scTarget.selectedFilters,
            [action.payload.key]: action.payload.value,
          },
        },
      };
    }
    case types.GET_ACTIVITIES_TEMPLATE_LIST: {
      return {
        ...state,
        activitiesTemplateList: action.payload,
      };
    }
    case types.SET_SALES_CATALYST_PREFERENCE_DATA : {
      return generateObject(state, action.data);
    }
    case types.UPDATE_SALES_CATALYST_SESSION_STUDY: {
      return {
        ...state,
        scSessionConfiguration: action.configurationObj,
      };
    }
    default:
      return state;
  }
}
